<template>
        <div>
            <h3 style="text-align:center">{{ order_name }}</h3>
            
            <a-divider orientation="center">{{ $t('returnExchange.baseInfo') }}</a-divider>
            <Form class="returnForm" :form="reissueForm1"></Form>

            <a-divider orientation="center">{{ $t('order.reissueInfo') }}</a-divider>
            <Form 
                class="returnForm" 
                :form="reissueForm2" 
                @handleInputChange="handleInputChangeForm2" 
                @handleSelectChange="handleSelectChangeForm2"
            ></Form>
            <Upload
                ref="upload"
                class="uploadImg"
                @changeUpload="changeUpload"
                @errorUpload="errorUpload"
            >
                <template #desc>
                    <div class="uploadDesc">{{ $t('returnExchange.uploadDesc') }}</div>
                </template>
            </Upload>

            <a-divider orientation="center">{{ $t('returnExchange.orderLineInfo') }}</a-divider>
            <!-- 调整弹窗宽度 -->
            <a-radio-group v-model="activeKey" type="button">
                <a-radio value="large" @click="handleWidth('large')">{{ $t('base.large')}}</a-radio>
                <a-radio value="medium" @click="handleWidth('medium')">{{ $t('base.medium')}}</a-radio>
                <a-radio value="small" @click="handleWidth('small')">{{ $t('base.small')}}</a-radio>
            </a-radio-group>

            <Table
                class="deliverTable"
                ref="tableRef"
                :table="table"
                @selectRow="selectRow"
                @selectAllRow="selectRowAll"
                @changePage="changeVersionPage"
                @changePageSize="changeVersionPageSize"
            >
                <template v-slot:columns="{ props }">
                    <div v-if="props.column.key == 'swap_type'">
                        <a-select 
                            v-model="props.record.swap_type" 
                            :style="{width:'100px'}" 
                            allow-search 
                            @change="(val)=>changeSwapType(val,props.record)"
                        >
                            <a-option 
                                v-for="(item,index) in swapTypeOptions" 
                                :key="index"
                            >
                                {{ item.label }}
                            </a-option>
                        </a-select>
                    </div>
                    <div v-if="props.column.key == 'swap_quantity'">
                        <a-inputNumber 
                            v-model="props.record.swap_quantity" 
                            :style="{width:'80px'}" 
                            :min="1"
                            :max="9999"
                            :precision="0"
                            :hideButton="true"
                        />
                    </div>
                    <div v-if="props.column.key == 'swap_inventory_code'">
                        <a-select 
                            v-model="props.record.swap_inventory_code" 
                            :style="{width:'250px'}" 
                            allow-search 
                            :loading="props.record.loading"
                            :disabled="props.record.swapInventoryCodeDisabled"
                            @change="(val)=>changeInventoryCode(val,props.record)"
                        >
                            <a-option v-for="(item,index) in props.record.inventoryCodeOptions" :key="index">
                                {{ item.label }}
                            </a-option>
                        </a-select>
                    </div>
                    <div v-if="props.column.key == 'swap_inventory'">
                        <a-select 
                            v-model="props.record.swap_inventory" 
                            :style="{width:'250px'}" 
                            allow-search
                            @change="(val)=>changeInventory(val,props.record)"
                        >
                            <a-option 
                                v-for="(item,index) in swapInventoryOptions" 
                                :key="index" 
                                :disabled="item.disabled"
                            >
                                {{ item.label }}
                            </a-option>
                        </a-select>
                    </div>
                    <div v-if="props.column.key == 'instruction'">
                        <a-input 
                        :style="{width:'270px'}"
                        v-model="props.record.instruction" 
                        placeholder="Please enter something" 
                        allow-clear />
                    </div>
                </template>

                <template v-slot:tableOperate="{ props }">
                    <a-button
                        v-if="props.record.isEdit"
                        :disabled="table.datas.length == 1"
                        type="text" status="danger" size="mini"
                        @click="removeLine(props.record)"
                    > <icon-minus-circle :size="20"/></a-button>
                </template>
            </Table>
            <div class="addLineIcon" @click="addLineIcon"><icon-plus /></div>
        </div>  
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import Upload from '@/components/Upload.vue';
    import { ReissueForm1,ReissueForm2 } from './queryConfig/ReissueForm.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';

    const props = defineProps({
        row:{
            type:Object,
            default:()=>{}
        },
        visible:{
            type:Boolean,
            default:false,
        }
    })

    const emits = defineEmits(['handleReissueWidth'])
    const { t } = useI18n()
    const tableRef = ref(null)
    const rowData = ref(null)
    const order_name =ref('')
    const createForm = reactive(null)
    const reissueForm1 = reactive(ReissueForm1)
    const reissueForm2 = reactive(ReissueForm2)
    const activeKey = ref('medium')
    const selected = ref([])
    const columns = ref([
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'product_name',
                key: 'product_name',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                // slotName:'sku',
                // slotName:'slot'
            },
            // {
            //     // title: '品牌名称',
            //     title:t('order.brandName'),
            //     dataIndex: 'brand_name',
            //     key: 'brand_name',
            //     width: '160',
            //     align: 'center',
            //     ellipsis:true,
            //     tooltip:true,
            //     show:true,
            // },
            // {
            //     // title: '零件名称',
            //     title:t('order.partName'),
            //     dataIndex: 'part_name',
            //     key: 'part_name',
            //     width: '160',
            //     align: 'center',
            //     ellipsis:true,
            //     tooltip:true,
            //     show:true,
            // },
            {
                // title: '物料编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key: 'inventory_code',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
            },
            // {
            //     // title: 'ERP行号',
            //     title:t('order.erpLineNo'),
            //     dataIndex: 'erp_line_no',
            //     key: 'erp_line_no',
            //     width: '130',
            //     align: 'center',
            //     ellipsis:true,
            //     tooltip:true,
            //     show:true,
            // },
            {
                // title: '换货类型',
                title:t('order.reissueType'),
                dataIndex: 'swap_type',
                key: 'swap_type',
                width: '130',
                align: 'center',
                show:true,
                slotName:'slot',
            },
            
            // {
            //     // title: 'bom类别',
            //     title:t('returnExchange.bomCategory'),
            //     dataIndex: 'bom_category',
            //     key: 'bom_category',
            //     width: '520',
            //     align: 'center',
            //     show:true,
            //     slotName:'slot',
            // },
            // {
            //     // title: 'bom的换货物料编码',
            //     title:t('order.bom'),
            //     dataIndex: 'bom',
            //     key: 'bom',
            //     width: '320',
            //     align: 'center',
            //     show:true,
            //     slotName:'slot',
            // },
            {
                // title: '整车的换货物料编码',
                title:t('order.swapInventoryCode'),
                dataIndex: 'swap_inventory_code',
                key: 'swap_inventory_code',
                width: '270',
                align: 'center',
                show:true,
                slotName:'slot',
            },
            {
                // title: '换货仓库',
                title:t('returnExchange.warehouse'),
                dataIndex: 'swap_inventory',
                key: 'swap_inventory',
                width: '270',
                align: 'center',
                show:true,
                slotName:'slot',
            },
            {
                // title: '补寄数量',
                title:t('order.reissueQuantity'),
                dataIndex: 'swap_quantity',
                key: 'swap_quantity',
                width: '150',
                align: 'center',
                show:true,
                slotName:'slot',
            },
            {
                // title: '库存',
                title:t('order.stockQuantity'),
                dataIndex: 'transaction_quantity',
                key: 'transaction_quantity',
                width: '120',
                align: 'center',
                show:true,
            },
            {
                // title: '行备注',
                title:t('order.instruction'),
                dataIndex: 'instruction',
                key: 'instruction',
                width: '300',
                align: 'center',
                show:true,
                slotName:'slot',
            },
            // {
            //     // title: '通用物料备注',
            //     title:t('returnExchange.inventoryRemark'),
            //     dataIndex: 'inventory_remark',
            //     key: 'inventory_remark',
            //     width: '300',
            //     align: 'center',
            //     show:true,
            //     slotName:'slot',
            // },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '90',
                align: 'center',
                fixed:'right',
                show:true,
            }
    ])
    const table = ref({
        datas:[],
        columns:columns.value,
        configs:{
            scroll:{
                x:1000,
                y: 480
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            // rowSelection:{
            //     type: 'checkbox',
            //     showCheckedAll: true,
            //     onlyCurrent: false,
            // },
            // selected:[],
            expandable:'',
            expand:false,
            pagination:false,
        },
    })
    const swapInventoryOptions = ref([])
    const bikeOptions = ref([])
    const bomOptions = ref([])
    const swapTypeOptions = ref([
        {
            label:t('returnExchange.bike'),
            value:1,
        },
        {
            label:t('returnExchange.bom'),
            value:2,
        }
    ])
    const upload = ref([])
    const skuOptions = ref([])
    const rowIndex = ref(0)

    const handleWidth = (type)=>{
        activeKey.value = type
        emits('handleReissueWidth',type)
    }   

    const init = ()=>{
        reissueForm1.formField.forEach(i=>{
            if(i.key !== 'type' && i.key !== 'source'){
                reissueForm1.formData[i.key] = ''
            }
        })
        reissueForm2.formField.forEach(i=>{
            reissueForm2.formData[i.key] = ''
            if(i.key == 'swap_courier_no'){
                i.disabled = true
                i.required = false
            }
        })

        reissueForm1.formData.type = 3
        reissueForm1.formData.status = 5
        reissueForm1.formData.source = rowData.value.source
        reissueForm1.formData.source_val = rowData.value.source_val
        reissueForm1.formData.order_id = rowData.value.id
        reissueForm1.formData.erp_no = rowData.value.erp_no == '-'? '' : rowData.value.erp_no
        reissueForm1.formData.customer_entity_id = rowData.value.customer_entity_id
        reissueForm1.formData.customer_id = rowData.value.customer_id
        reissueForm1.formData.customer_name = rowData.value.customer_name
        reissueForm1.formData.customer_erp_code = rowData.value.customer_erp_code
        reissueForm1.formData.file = ''

        reissueForm2.formData.swap_courier_id = ''
        upload.value.fileList = []
        reissueForm2.formData.file = ''

        // 重置表格
        table.value.datas = []
        addLineIcon()
    }

    const handleInputChangeForm2 = (item,val)=>{
        // console.log(item,val,'val,opt,item7777')

        if(item.key == 'swap_courier_no' && !!val){
            getSwapCourierId()
        }else if(!val){
            reissueForm2.formData.swap_courier_id = ''
        }
    }

    const handleSelectChangeForm2 = (val,opt,key)=>{
        if(key == 'swap_courier_type'){
            let courierNoItem = reissueForm2.formField.find(i=> i.key == 'swap_courier_no')
            courierNoItem.required = !!reissueForm2.formData.swap_courier_type
            if(!!val && reissueForm2.formData.swap_courier_no === ''){
                courierNoItem.disabled = false
            }else if(!!val && reissueForm2.formData.swap_courier_no !== ''){
                getSwapCourierId()
            }else{
                reissueForm2.formData.swap_courier_no = ''
                reissueForm2.formData.swap_courier_id = ''
                courierNoItem.disabled = true
            }
        }
    }

    const selectRow = (val)=>{
        // console.log(val,'selectRow')
    }

    const changeSku = (val,row)=>{
        // console.log(val,'kkjjj')
    }

    const selectRowAll = (val)=>{
        // selected.value = val
        // console.log(selected.value,'select')
    }

    // 获取库存仓库下拉配置
    const getWarehouseConfig = async()=>{
        let param = {
            dict_code: "config",
            dict_sub_code:'bom_available_warehouse',
        }
        let res = await OrderApi.getInstance().getWarehouseConfig(param)
        if(res.code == 0){
            return res.data.map(item => item.dict_sub_value)
        }else{
            Message.error(res.msg)
        }
    }

    const changeSwapType = async (val,row)=>{
        console.log(val,row,'changeSwapType')
        let typeItem = swapTypeOptions.value.find(i=> i.label == val)
        row.swap_type_val = typeItem.value
        row.swapInventoryCodeDisabled = false

        if(row.swap_type_val == 2){
            const warehouseVals = await getWarehouseConfig();
            swapInventoryOptions.value = swapInventoryOptions.value.filter(i=>{
                i.disabled = !warehouseVals.includes(i.value)
                // i.disabled = i.value != 'HFRM03' && i.value != 'HFRM05'
                return i
            })
        }else{
            swapInventoryOptions.value = swapInventoryOptions.value.filter(i=>{
                i.disabled = false
                return i
            })
        }

        let warehouseItem1 = swapInventoryOptions.value.find(i=> i.value == 'HFFG01') // 成品仓
        // let warehouseItem2 = swapInventoryOptions.value.find(i=> i.value == 'HFRM01') // 原材料仓
        let warehouseItem2 = swapInventoryOptions.value.find(i=> i.value == 'HFRM03') // 配件发货都只能从HFRM03和HFRM04 出
        row.swap_inventory = row.swap_type_val == 2? warehouseItem2.label : warehouseItem1.label
        row.swap_inventory_val = row.swap_type_val == 2? 'HFRM03' : 'HFFG01'

        // 重置bom、整车换货物料编码
        row.product_name = '-'
        row.sku = '-'
        row.inventory_code = '-'
        row.swap_inventory_code = ''
        row.swap_inventory_code_val = ''
        row.transaction_quantity = ''

        if(row.swap_type_val == 1){
            row.inventoryCodeOptions = bikeOptions.value.length == 0? getBike(row) : bikeOptions.value    
        }else{
            row.inventoryCodeOptions = bomOptions.value.length == 0? getBom(row) : bomOptions.value
        }

        // 控制物料编码字段显示/隐藏
        // controlColumnShow(row)
    }

    // 控制物料编码字段显示/隐藏
    const controlColumnShow = (row)=>{
        
    }

    const changeBomCategory = (val,row)=>{
        
    }

    const changeBom = (val,row)=>{
        
    }

    const changeInventoryCode = (val,row)=>{
        // console.log(val,row,'changeInventoryCode')
        let item = row.inventoryCodeOptions.find(i=> i.label == val)
        row.product_name = item.product_name
        row.sku = item.sku
        row.inventory_code = item.inventory_code
        row.swap_inventory_code_val = item.value
        row.swap_sku = item.sku
    }

    const changeInventory = (val,row)=>{
        // console.log(val,row,'mmmmmmmm111')
    }

    // 上传中
    const changeUpload = (fileList)=>{
        let arr = []
        if(fileList.length > 0){
            fileList.forEach(i=>{
                if(i.status == 'done'){
                    arr.push(i.response.data)
                }
            })
        }
        reissueForm2.formData.file = arr.join(',')
    }

    // 上传失败
    const errorUpload = (fileItem)=>{
        // console.log(fileItem,'失败')
        Message.error(t('returnExchange.uploadFail'))
    }

    // 新增订单行
    const addLineIcon = ()=>{
        rowIndex.value += 1
        table.value.datas.push({
            id:rowIndex.value,
            product_name:'-',
            sku:'-',
            inventory_code:'-',
            swap_type:'',
            swap_type_val:'',
            swap_quantity:'',
            swap_inventory_code:'',
            swap_inventory: '',
            swap_inventory_val:'',
            instruction:'',
            swapInventoryCodeDisabled:false,
            isEdit:true,
        })
    }

    // 删除新增的订单行
    const removeLine = (row)=>{
        table.value.datas.forEach((i,index)=> {i.index = index})
        let tableItem = table.value.datas.find(i=> i.index == row.index)
        table.value.datas.splice(tableItem.index,1)

        // 控制物料编码字段显示/隐藏
        // controlColumnShow(row)
    }

    // 获取原因类型
    const getReasonType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "reissue_reason_type"})
        if(res.code == 0){
            let item = reissueForm2.formField.find(i=> i.key == 'back_reason_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流公司
    const getCourierType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "courier_back"})
        if(res.code == 0){
            let item = reissueForm2.formField.find(i=> i.key == 'swap_courier_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取换货物流id
    const getSwapCourierId = async ()=>{
        let param = {
            courier_type: reissueForm2.formData.swap_courier_type,
            courier_no: reissueForm2.formData.swap_courier_no,
        }
        let res = await OrderApi.getInstance().getCourierId(param)
        if(res.code == 0){
            reissueForm2.formData.swap_courier_id = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取仓库
    const getWarehouse = async ()=>{
        let res = await OrderApi.getInstance().getWarehouse()
        if(res.code == 0){
            swapInventoryOptions.value = []
            res.data.length > 0 && res.data.forEach(i=>{
                swapInventoryOptions.value.push({
                    label: `${i.description} (${i.subinventory_name})`,
                    value: i.subinventory_name,
                    disabled: false,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表,拿到整车物料编码下拉数据
    const getProductList = async ()=>{
        
    }

     // 获取bom类别
     const getBomCategory = async ()=>{
        
    }

    // 获取bom物料编码
    const getBom = async ( row)=>{
        // console.log(row,'getBom')
        if(row) row.loading = true
        let param = {
            inventory_item_status_code:'Active',
            category_code: row.swap_type_val == 1? '627.501' : '000.000'
        }
        let res = await OrderApi.getInstance().getProductList(param)
        if(res.code == 0){
            bomOptions.value = []
            res.data.forEach(i=>{
                if(i.category_code != '627.501'){
                    let brandName = i.brand_name == undefined? 'null' : i.brand_name
                    let partName = i.part_name == undefined? 'null' : i.part_name
                    bomOptions.value.push({
                        label: i.english_name == undefined? i.inventory_code : `${i.inventory_code} | ${i.english_name} | ${brandName} | ${partName}`,
                        value: i.inventory_code,
                        product_name: i.english_name,
                        sku:i.sku,
                        inventory_code: i.inventory_code,
                        product_code: i.category_code,
                    })
                }
            })
            row.inventoryCodeOptions = bomOptions.value
            // console.log(row.inventoryCodeOptions,'row.inventoryCodeOptions')
            row.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车物料编码
    const getBike = async ( row)=>{
        if(row) row.loading = true
        let param = {
            category_code: row.swap_type_val == 1? '627.501' : '000.000'
        }
        let res = await OrderApi.getInstance().getProductList(param)
        if(res.code == 0){
            bikeOptions.value = []
            res.data.forEach(i=>{
                if(i.category_code == '627.501'){
                    let model = i.model == undefined? 'null' : i.model
                    let modelYear = i.model_year == undefined? 'null' : i.model_year
                    let brandName = i.brand_name == undefined? 'null' : i.brand_name
                    let partName = i.part_name == undefined? 'null' : i.part_name
                    bikeOptions.value.push({
                        label: i.english_name == undefined? i.sku : `${i.sku} | ${i.english_name} | ${model} | ${modelYear} | ${brandName} | ${partName}`,
                        value: i.inventory_code,
                        product_name: i.english_name,
                        sku:i.sku,
                        inventory_code: i.inventory_code,
                        product_code: i.category_code,
                    })
                }
            })
            row.inventoryCodeOptions = bikeOptions.value
            row.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 根据仓库查库存
    const getInventories = async (warehouse,inventoryCode,row)=>{
        let param = {
            inventory_code: inventoryCode,
        }
        let res = await OrderApi.getInstance().getExistBom(param,warehouse)
        if(res.code == 0){
            if(res.data && res.data.length > 0){
                res.data.forEach(c=>{
                    if(inventoryCode == c.inventory_code){
                        row.transaction_quantity = c.inventory
                    }
                })
            }else{
                row.transaction_quantity = 0
            }   
        }else{
            Message.error(res.msg)
        }
    }
   

    watch(()=>props.row,(nVal,oVal)=>{
        rowData.value = nVal
        console.log(rowData,'rowData')
    })
    watch(()=>props.visible,async (nVal,oVal)=>{
        rowData.value = props.row
        order_name.value = props.row.order_name
        getReasonType()
        getCourierType()
        await getWarehouse()
        init()
    })

    defineExpose({
        rowData,
        createForm,
        reissueForm1,
        reissueForm2,
        table
    })

    onMounted(async ()=>{
        getWarehouseConfig()
    })
</script>

<style lang="less" scoped>
.returnForm{
    min-width: 70%;
    max-width:75%;
    margin:0 auto;
    padding:20px;

    /deep/ .arco-form{
        display: block;
        text-align: center;
    }

    /deep/ .arco-input-wrapper .arco-input{
        height: 30px;
        width:100%;
    }

    /deep/ .arco-select,
    /deep/ .arco-textarea,
    /deep/ .arco-picker{
        height: 40px;
    }
}

/deep/ .arco-table-th{
    background-color: #333 !important;
    color: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 0;
    font-weight: 300;
    font-size:12px;
}

.deliverTable{
    /deep/ .arco-pagination{
        display:none;
    }
}


.uploadImg{
    /deep/ .arco-form-item-content-flex{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 8px;
        margin-left: 20px;
    }
}
.uploadDesc{
    margin-bottom: 3px;
    font-size: 12px;
    color: #4d83ff;
}   

.addLineIcon{
    margin-top:15px;
    width:99%;
    border: 1px dashed #ccc;
    color:#333;
    text-align: center;
    cursor:pointer;

    &:hover{
        background: #fff;
        opacity: .5;
    }
}
</style>